<!-- Status bar -->
<div class="status-bar" [class.visible]="step === 'streaming'">
  <span class="status-dot" [class.live]="isConnected"></span>
  <span class="status-label">{{ isConnected ? 'LIVE' : 'OFFLINE' }}</span>
  <button class="btn-refresh-stream"
          *ngIf="step === 'streaming'"
          [disabled]="isRefreshing"
          (click)="refreshStream()"
          title="Refresh stream if stuck on a frame"
          [featureActionState]="'MOBILE_AUTOMATION'">
    <span *ngIf="!isRefreshing">⟳ Refresh Frame</span>
    <span *ngIf="isRefreshing" class="refresh-spinner"></span>
  </button>
  <ng-content select="[slot=end-button]"></ng-content>
</div>

<!-- Phone frame + hardware buttons -->
<div class="device-container">

  <!-- Left: volume & power -->
  <div class="hw-buttons hw-buttons--left">
    <button class="hw-btn" title="Volume Up"   (click)="pressVolumeUp()" [featureActionState]="'MOBILE_AUTOMATION'">
      <span class="hw-icon">▲</span><span class="hw-label">VOL+</span>
    </button>
    <button class="hw-btn" title="Volume Down" (click)="pressVolumeDown()" [featureActionState]="'MOBILE_AUTOMATION'">
      <span class="hw-icon">▼</span><span class="hw-label">VOL−</span>
    </button>
    <button class="hw-btn" title="Power"       (click)="pressPower()" [featureActionState]="'MOBILE_AUTOMATION'">
      <span class="hw-icon">⏻</span><span class="hw-label">PWR</span>
    </button>
    <!-- IME / Keyboard action button -->
    <button class="hw-btn hw-btn--ime" title="Keyboard Actions" (click)="toggleImeMenu($event)" [featureActionState]="'MOBILE_AUTOMATION'">
      <span class="hw-icon">⌨</span><span class="hw-label">IME</span>
    </button>
  </div>

  <!-- Screen -->
  <div class="screen-wrapper" [style.height]="screenHeight">

    <!-- Boot overlay -->
    <div class="boot-overlay" *ngIf="step === 'connecting'">
      <div class="boot-screen">
        <div class="boot-logo">
          <div class="boot-ring boot-ring--1"></div>
          <div class="boot-ring boot-ring--2"></div>
          <div class="boot-ring boot-ring--3"></div>
          <div class="boot-core"><span class="boot-android"><img [src]="brand.loginLogo" class="boot-image" [alt]="brand.brandName" /></span></div>
        </div>
        <div class="boot-brand">ANDROID</div>
        <div class="boot-dots">
          <span class="boot-dot"></span>
          <span class="boot-dot"></span>
          <span class="boot-dot"></span>
        </div>
        <div class="boot-label">Initializing Device...</div>
      </div>
    </div>

    <!-- Idle overlay -->
    <div class="idle-overlay" *ngIf="step === 'upload' || step === 'error'">
      <div class="idle-content">
        <div class="idle-icon"><img [src]="brand.loginLogo" class="boot-image" [alt]="brand.brandName" /></div>
        <p class="idle-text">Upload an APK →</p>
        <p class="idle-sub">to start a live session</p>
      </div>
    </div>

    <img #screenImage class="device-image-hidden" alt=""/>
    <canvas #screenCanvas class="device-canvas"></canvas>
    <canvas #overlayCanvas class="device-canvas device-overlay"
      [style.pointer-events]="isModalOpen ? 'none' : 'all'"
      [style.cursor]="fingerMode === '2' && selectedMode === gestureLiterals.TWO_FINGER_SWIPE ? 'crosshair' : 'pointer'"
      [featureActionState]="'MOBILE_AUTOMATION'">
    </canvas>
  </div>

  <!-- Right: nav buttons -->
  <div class="hw-buttons hw-buttons--right">
    <button class="hw-btn hw-btn--nav" title="Back"    (click)="pressBack()" [featureActionState]="'MOBILE_AUTOMATION'">
      <span class="hw-icon">◀</span><span class="hw-label">Back</span>
    </button>
    <button class="hw-btn hw-btn--nav" title="Home"    (click)="pressHome()" [featureActionState]="'MOBILE_AUTOMATION'">
      <span class="hw-icon">⬤</span><span class="hw-label">Home</span>
    </button>
    <button class="hw-btn hw-btn--nav" title="Recents" (click)="pressRecents()" [featureActionState]="'MOBILE_AUTOMATION'">
      <span class="hw-icon">▣</span><span class="hw-label">Apps</span>
    </button>
  </div>
</div>

<!-- IME action dropdown -->
<div class="ime-backdrop" *ngIf="showImeMenu" (click)="closeImeMenu()"></div>
<div class="ime-menu" *ngIf="showImeMenu" [style.top.px]="imeMenuY" [style.left.px]="imeMenuX">
  <div class="ime-menu-header">⌨ Keyboard Action</div>
  <button class="ime-menu-item" (click)="pressKeyboardAction('search')" [featureActionState]="'MOBILE_AUTOMATION'">Search</button>
  <button class="ime-menu-item" (click)="pressKeyboardAction('done')" [featureActionState]="'MOBILE_AUTOMATION'">Done</button>
  <button class="ime-menu-item" (click)="pressKeyboardAction('go')" [featureActionState]="'MOBILE_AUTOMATION'">Go</button>
  <button class="ime-menu-item" (click)="pressKeyboardAction('send')" [featureActionState]="'MOBILE_AUTOMATION'">Send</button>
  <button class="ime-menu-item" (click)="pressKeyboardAction('next')" [featureActionState]="'MOBILE_AUTOMATION'">Next</button>
  <button class="ime-menu-item" (click)="pressKeyboardAction('previous')" [featureActionState]="'MOBILE_AUTOMATION'">Previous</button>
  <button class="ime-menu-item" (click)="pressKeyboardAction('enter')" [featureActionState]="'MOBILE_AUTOMATION'">Enter</button>
</div>

<!-- Right-click context menu -->
<div class="ctx-menu-backdrop" *ngIf="showContextMenu" (click)="dismissContextMenu()"></div>
<div class="ctx-menu"
     #ctxMenu
     *ngIf="showContextMenu"
     [style.left.px]="contextMenuX"
     [style.top.px]="contextMenuY"
     [style.visibility]="contextMenuVisible ? 'visible' : 'hidden'">

  <div class="ctx-menu-header">
    <span class="ctx-menu-title">Inspect Element</span>
    <span class="ctx-menu-coords">({{ contextMenuRealX }}, {{ contextMenuRealY }})</span>
  </div>

  <button class="ctx-menu-item" (click)="contextMenuInspect('get-text')" [featureActionState]="'MOBILE_AUTOMATION'">
    <span class="ctx-item-label">Get Text</span>
    <span class="ctx-item-hint">element.text</span>
  </button>
  <button class="ctx-menu-item" (click)="contextMenuInspect('verify-text')" [featureActionState]="'MOBILE_AUTOMATION'">
    <span class="ctx-item-label">Verify Text</span>
    <span class="ctx-item-hint">element.text</span>
  </button>
  <button class="ctx-menu-item" (click)="contextMenuInspect('assert-text')" [featureActionState]="'MOBILE_AUTOMATION'">
    <span class="ctx-item-label">Assert Text</span>
    <span class="ctx-item-hint">element.text</span>
  </button>
  <button class="ctx-menu-item" (click)="contextMenuInspect('verify-text-contains')" [featureActionState]="'MOBILE_AUTOMATION'">
    <span class="ctx-item-label">Verify Text Contains</span>
    <span class="ctx-item-hint">element.text</span>
  </button>

  <button class="ctx-menu-item" (click)="contextMenuRecordSlider()" [featureActionState]="'MOBILE_AUTOMATION'">
    <span class="ctx-item-label">Slider</span>
  </button>

</div>